/**
 * XP và cấp người chơi (M3: nhiệm vụ hằng ngày + đơn lớn thật).
 *
 * - Công thức cấp: XP tích lũy để đạt cấp n = P15 × n(n−1)/2.
 *   (Suy từ mốc bảng tính: cấp 3 ở 1,2h, cấp 6 ở 6h, cấp 10 ở 18h
 *   với nhịp 250 XP/giờ thực — xem decisions-m1.md.)
 * - Nguồn XP M3: mỗi món bán (M06), NV hằng ngày hoàn thành (thưởng theo mẫu),
 *   đơn lớn hoàn thành (thưởng theo mẫu), mốc bán hàng (M11/M12),
 *   lên cấp thân thiết NPC (M18).
 */
import { layThamSo, layThamSoMoPhong } from './du-lieu.js';
import type { DuLieuGame, TrangThaiGame } from './types.js';

/** XP tích lũy cần để đạt cấp n (n ≥ 1). Cấp 1 cần 0 XP. */
export function xpCanChoCap(cap: number, duLieu: DuLieuGame): number {
  if (cap <= 1) return 0;
  return (layThamSo(duLieu, 'P15') * cap * (cap - 1)) / 2;
}

/** Cấp người chơi tương ứng với tổng XP (kẹp ở P14). */
export function capTuXp(xp: number, duLieu: DuLieuGame): number {
  const toiDa = layThamSo(duLieu, 'P14');
  let cap = 1;
  while (cap < toiDa && xp >= xpCanChoCap(cap + 1, duLieu)) cap += 1;
  return cap;
}

/** Cộng XP, lên cấp nếu đủ, ghi mốc thời gian. Trả về cấp mới. */
export function congXp(state: TrangThaiGame, duLieu: DuLieuGame, luongXp: number): number {
  if (luongXp <= 0) return state.nguoiChoi.cap;
  state.nguoiChoi.xp += luongXp;
  const moi = capTuXp(state.nguoiChoi.xp, duLieu);
  if (moi > state.nguoiChoi.cap) {
    state.nguoiChoi.cap = moi;
    state.mocCapNguoiChoi.push({ cap: moi, gioThuc: state.tongGioGame / 60 });
  }
  return moi;
}

/** Thưởng mốc bán hàng: mỗi M11 món tích lũy → +M12 XP. */
export function xuLyMocBanHang(state: TrangThaiGame, duLieu: DuLieuGame): void {
  const buoc = layThamSoMoPhong(duLieu, 'M11');
  const thuong = layThamSoMoPhong(duLieu, 'M12');
  while (state.thongKe.tongMonDaBan >= state.mocBanHangTiep) {
    state.mocBanHangTiep += buoc;
    congXp(state, duLieu, thuong);
  }
}
